 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"alerta-preco~catalogos~configuracao-frete~configuracao-venda~dashboard-acessos~finalizacao~grades~in~d08f83bb":"alerta-preco~catalogos~configuracao-frete~configuracao-venda~dashboard-acessos~finalizacao~grades~in~d08f83bb","alerta-preco":"alerta-preco","catalogos":"catalogos","configuracao-frete":"configuracao-frete","configuracao-venda":"configuracao-venda","dashboard-acessos":"dashboard-acessos","finalizacao":"finalizacao","grades":"grades","indicadores-catalogo":"indicadores-catalogo","indicadores-marketplace":"indicadores-marketplace","lista-cotacao":"lista-cotacao","minha-resposta":"minha-resposta","ofertas":"ofertas","ofertas-mktplace":"ofertas-mktplace","pendencias":"pendencias","produtos":"produtos","resposta":"resposta","usuarios":"usuarios","vendas":"vendas","cadastro-usuarios":"cadastro-usuarios","cotacao":"cotacao","cotacao-conjunta":"cotacao-conjunta","cotacao-conjunta-minha-resposta":"cotacao-conjunta-minha-resposta","cotacao-conjunta-resposta":"cotacao-conjunta-resposta","cotacao-conjunta-vendas":"cotacao-conjunta-vendas","edicao-catalogos":"edicao-catalogos","edicao-configuracao-frete":"edicao-configuracao-frete","edicao-configuracao-venda":"edicao-configuracao-venda","edicao-grades":"edicao-grades","edicao-oferta":"edicao-oferta","edicao-produtos":"edicao-produtos","feedback":"feedback","meu-painel":"meu-painel","minha-conta":"minha-conta","minha-empresa":"minha-empresa","minha-pagina":"minha-pagina","oferta":"oferta","oferta-mktplace":"oferta-mktplace","ofertas-edicao-mktplace":"ofertas-edicao-mktplace","ofertas-edicao-rapida":"ofertas-edicao-rapida","venda":"venda"}[chunkId]||chunkId) + "." + {"alerta-preco~catalogos~configuracao-frete~configuracao-venda~dashboard-acessos~finalizacao~grades~in~d08f83bb":"ca189900","alerta-preco":"08098c8f","catalogos":"49e59bfe","configuracao-frete":"52098820","configuracao-venda":"c13230d6","dashboard-acessos":"2ff32e41","finalizacao":"276a6847","grades":"a70b1454","indicadores-catalogo":"fefc5393","indicadores-marketplace":"35b97c1b","lista-cotacao":"85efefec","minha-resposta":"d00f938a","ofertas":"349693dd","ofertas-mktplace":"f5bc4129","pendencias":"8ff82bcf","produtos":"632904fe","resposta":"5934af5c","usuarios":"cc5309bc","vendas":"c329d21d","cadastro-usuarios":"fcf97ad0","cotacao":"51cfb4b8","cotacao-conjunta":"8575ad09","cotacao-conjunta-minha-resposta":"fa58e963","cotacao-conjunta-resposta":"4cc95d26","cotacao-conjunta-vendas":"108d43b2","edicao-catalogos":"edd05fb8","edicao-configuracao-frete":"4c604732","edicao-configuracao-venda":"b5f231e8","edicao-grades":"5098f29e","edicao-oferta":"75c94814","edicao-produtos":"790e96ef","feedback":"f7cc87db","meu-painel":"2163a767","minha-conta":"17afe3f3","minha-empresa":"232c698a","minha-pagina":"5641210a","oferta":"7fd1b4d6","oferta-mktplace":"21f5860c","ofertas-edicao-mktplace":"68f3281a","ofertas-edicao-rapida":"2c5a967f","venda":"5bb72d1d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"alerta-preco~catalogos~configuracao-frete~configuracao-venda~dashboard-acessos~finalizacao~grades~in~d08f83bb":1,"dashboard-acessos":1,"finalizacao":1,"indicadores-marketplace":1,"minha-resposta":1,"ofertas":1,"resposta":1,"usuarios":1,"vendas":1,"cotacao":1,"cotacao-conjunta":1,"cotacao-conjunta-minha-resposta":1,"cotacao-conjunta-resposta":1,"cotacao-conjunta-vendas":1,"edicao-catalogos":1,"edicao-configuracao-frete":1,"edicao-configuracao-venda":1,"edicao-grades":1,"edicao-oferta":1,"feedback":1,"meu-painel":1,"minha-pagina":1,"oferta":1,"oferta-mktplace":1,"ofertas-edicao-mktplace":1,"ofertas-edicao-rapida":1,"venda":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"alerta-preco~catalogos~configuracao-frete~configuracao-venda~dashboard-acessos~finalizacao~grades~in~d08f83bb":"alerta-preco~catalogos~configuracao-frete~configuracao-venda~dashboard-acessos~finalizacao~grades~in~d08f83bb","alerta-preco":"alerta-preco","catalogos":"catalogos","configuracao-frete":"configuracao-frete","configuracao-venda":"configuracao-venda","dashboard-acessos":"dashboard-acessos","finalizacao":"finalizacao","grades":"grades","indicadores-catalogo":"indicadores-catalogo","indicadores-marketplace":"indicadores-marketplace","lista-cotacao":"lista-cotacao","minha-resposta":"minha-resposta","ofertas":"ofertas","ofertas-mktplace":"ofertas-mktplace","pendencias":"pendencias","produtos":"produtos","resposta":"resposta","usuarios":"usuarios","vendas":"vendas","cadastro-usuarios":"cadastro-usuarios","cotacao":"cotacao","cotacao-conjunta":"cotacao-conjunta","cotacao-conjunta-minha-resposta":"cotacao-conjunta-minha-resposta","cotacao-conjunta-resposta":"cotacao-conjunta-resposta","cotacao-conjunta-vendas":"cotacao-conjunta-vendas","edicao-catalogos":"edicao-catalogos","edicao-configuracao-frete":"edicao-configuracao-frete","edicao-configuracao-venda":"edicao-configuracao-venda","edicao-grades":"edicao-grades","edicao-oferta":"edicao-oferta","edicao-produtos":"edicao-produtos","feedback":"feedback","meu-painel":"meu-painel","minha-conta":"minha-conta","minha-empresa":"minha-empresa","minha-pagina":"minha-pagina","oferta":"oferta","oferta-mktplace":"oferta-mktplace","ofertas-edicao-mktplace":"ofertas-edicao-mktplace","ofertas-edicao-rapida":"ofertas-edicao-rapida","venda":"venda"}[chunkId]||chunkId) + "." + {"alerta-preco~catalogos~configuracao-frete~configuracao-venda~dashboard-acessos~finalizacao~grades~in~d08f83bb":"c2950afa","alerta-preco":"31d6cfe0","catalogos":"31d6cfe0","configuracao-frete":"31d6cfe0","configuracao-venda":"31d6cfe0","dashboard-acessos":"5b0832c2","finalizacao":"64a988ae","grades":"31d6cfe0","indicadores-catalogo":"31d6cfe0","indicadores-marketplace":"8ac8aa80","lista-cotacao":"31d6cfe0","minha-resposta":"7a4726f2","ofertas":"a1886b7c","ofertas-mktplace":"31d6cfe0","pendencias":"31d6cfe0","produtos":"31d6cfe0","resposta":"494ac91f","usuarios":"19b2d79e","vendas":"8ddbe3de","cadastro-usuarios":"31d6cfe0","cotacao":"c4c3ccab","cotacao-conjunta":"8ddbe3de","cotacao-conjunta-minha-resposta":"fc0bde67","cotacao-conjunta-resposta":"79cbbb64","cotacao-conjunta-vendas":"41d8ee17","edicao-catalogos":"09215ab3","edicao-configuracao-frete":"09215ab3","edicao-configuracao-venda":"09215ab3","edicao-grades":"19b2d79e","edicao-oferta":"19b2d79e","edicao-produtos":"31d6cfe0","feedback":"35750a48","meu-painel":"e1313045","minha-conta":"31d6cfe0","minha-empresa":"31d6cfe0","minha-pagina":"5b3842f2","oferta":"64a988ae","oferta-mktplace":"64a988ae","ofertas-edicao-mktplace":"609c2b68","ofertas-edicao-rapida":"b3b9c7b6","venda":"01f77492"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
